"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "baseColors", {
  enumerable: true,
  get: function get() {
    return _baseColors["default"];
  }
});
Object.defineProperty(exports, "baseColors_v2", {
  enumerable: true,
  get: function get() {
    return _baseColors2["default"];
  }
});
Object.defineProperty(exports, "defaultVersion", {
  enumerable: true,
  get: function get() {
    return _versions.defaultVersion;
  }
});
exports.pureColors = exports.colorPattern = exports["default"] = void 0;

var _v = _interopRequireDefault(require("../versions/v1"));

var _v2 = _interopRequireDefault(require("../versions/v2"));

var _baseColors = _interopRequireDefault(require("../versions/baseColors"));

var _baseColors2 = _interopRequireDefault(require("../versions/v2/baseColors"));

var _versions = require("../versions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var colors = {
  "default": _versions.defaultVersion,
  v1: _v["default"],
  v2: _v2["default"]
};
var pureColors = {
  v1: _baseColors["default"],
  v2: _baseColors2["default"]
};
exports.pureColors = pureColors;
var colorPattern = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})|^currentColor|^inherit|^initial$/;
exports.colorPattern = colorPattern;
var _default = colors;
exports["default"] = _default;